module.exports = __webpack_public_path__ + "img/mingob.5c2165ab.png";